module.exports = __webpack_public_path__ + "static/img/暂无足迹.9486548.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/暂无足迹.jpg
// module id = fGZ2
// module chunks = 1